export default {
  ev_charging_gun: {
    statuses: {
      offline: '离线',
      available: '空闲',
      ready: '准备充电',
      charging: '充电中',
      fault: '故障',
      unknown: '未知',
      charged: '充电完成'
    },
    gun_types: {
      ac: '交流',
      dc: '直流'
    },
    attr: {
      serial_number: '枪口编号',
      current: '额定电流',
      power: '额定功率',
      gun_type: '枪口类型',
      voltage: '额定电压'
    }
  }
}
